import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden" aria-label="主视觉区域">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20manga%20library%20interior%20with%20floating%20manga%20pages%20and%20soft%20glowing%20lanterns%2C%20traditional%20Japanese%20and%20Chinese%20art%20fusion%20style%2C%20warm%20amber%20and%20coral%20tones%2C%20dreamy%20atmosphere%2C%20bookshelves%20filled%20with%20colorful%20manga%20volumes%2C%20soft%20bokeh%20effects%2C%20magical%20reading%20environment%2C%20clean%20composition%2C%20no%20text&width=1800&height=900&seq=hero-bg-longjinman&orientation=landscape"
          alt="龙禁漫 - 正版漫画阅读平台"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/35 to-foreground-900/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm rounded-full border border-primary-400/30 mb-6">
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-verified-badge-line text-primary-300 text-sm"></i>
          </span>
          <span className="text-primary-200 text-xs md:text-sm font-medium">正版授权 · 海量漫画资源</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight">
          探索无限<span className="text-primary-300">漫画</span>世界
        </h1>
        <p className="text-background-200/90 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          龙禁漫专注于正版漫画内容，汇聚热血、恋爱、悬疑、奇幻等多元题材。
          无论你偏爱哪种风格，都能在这里找到属于你的精彩故事。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即开始阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
          <div className="flex items-center gap-2">
            <span className="w-10 h-10 flex items-center justify-center">
              <i className="ri-book-read-line text-accent-400 text-xl"></i>
            </span>
            <div className="text-left">
              <p className="text-background-50 font-heading text-lg font-bold">10,000+</p>
              <p className="text-background-300 text-xs">漫画资源</p>
            </div>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden md:block"></div>
          <div className="flex items-center gap-2">
            <span className="w-10 h-10 flex items-center justify-center">
              <i className="ri-user-heart-line text-accent-400 text-xl"></i>
            </span>
            <div className="text-left">
              <p className="text-background-50 font-heading text-lg font-bold">500万+</p>
              <p className="text-background-300 text-xs">活跃读者</p>
            </div>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden md:block"></div>
          <div className="flex items-center gap-2">
            <span className="w-10 h-10 flex items-center justify-center">
              <i className="ri-shield-check-line text-accent-400 text-xl"></i>
            </span>
            <div className="text-left">
              <p className="text-background-50 font-heading text-lg font-bold">100%</p>
              <p className="text-background-300 text-xs">正版授权</p>
            </div>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden md:block"></div>
          <div className="flex items-center gap-2">
            <span className="w-10 h-10 flex items-center justify-center">
              <i className="ri-download-cloud-line text-accent-400 text-xl"></i>
            </span>
            <div className="text-left">
              <p className="text-background-50 font-heading text-lg font-bold">离线下载</p>
              <p className="text-background-300 text-xs">随时随地</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}